import React, { useState } from "react";
import {
  FlexCenter,
  FlexCenterTop,
  FlexRowSB,
} from "../../constant/CustomeStyle";
import Topbar from "../../constant/Topbar/Topbar";
import LeftMenu from "./LeftMenu";
import RightMenuMenu from "./RightMenuMenu";
import RightProductMenu from "./RightProductMenu";
import RightWarehouseMenu from "./RightWarehouseMenu";
import WarehouseTypeMenu from "./WarehouseTypeMenu";

const ProductLayout = ({ children }) => {
  const [pOption, setPOption] = useState("Products List");
  const [sOption, setSOption] = useState("Products");

  const productOption = (e) => {
    setPOption(e);
  };

  const settingOption = (e) => {
    setSOption(e);
  };
  return (
    <div style={{ background: "#E5E5E5" }}>
      <Topbar />
      <FlexRowSB style={{ marginTop: 1 }}>
        <LeftMenu
          productOption={(e) => productOption(e)}
          settingOption={(e) => settingOption(e)}
        />

        <FlexCenterTop>
          <div style={{ width: 710, marginTop: 27 }}>{children}</div>
        </FlexCenterTop>

        {pOption === "Products List" ? (
          <RightProductMenu />
        ) : pOption === "Menu List" ? (
          <RightMenuMenu />
        ) : pOption === "Warehouse" ? (
          <RightWarehouseMenu />
        ) : pOption === "Warehouse Type" ? (
          <WarehouseTypeMenu />
        ) : null}
      </FlexRowSB>
    </div>
  );
};

export default ProductLayout;
